import HttpRequest from '@/util/HttpRequest'

export default {
  async FILE_UPLOAD ({commit}, params) {

    const formData = new FormData()
    formData.append('file_data', params)

    return new Promise((resolve, reject) => {
      HttpRequest.post('/api/v1/file', formData)
        .then(response => {
          commit('FILE_UPLOAD', response)
          resolve(response)
        }).catch(err => reject(err))
    })
  },

  async FILE_UPLOAD_NONE_TOKEN ({commit}, params) {

    const formData = new FormData()
    formData.append('file_data', params)

    return new Promise((resolve, reject) => {
      HttpRequest.post('/api/v1/file/pub', formData)
        .then(response => {
          commit('FILE_UPLOAD_NONE_TOKEN', response)
          resolve(response)
        }).catch(err => reject(err))
    })
  },
}
